import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SabreText } from '@shared/components/sabre-text-dialog/models/sabre-text';
import { AlertService } from '@shared/services/alert/alert.service';
import { DecsService } from '@shared/services/decs/decs.service';
import { RequestState } from '../../models/request-state';
import { DecsResponse } from './models/response/decs.response';

// Store service used for DECS requests.
@Injectable({
  providedIn: 'root',
})
export class DecsStore {
  refreshFn = (cmd: string) => this.submitDecsRequest(cmd, true);

  constructor(
    private decsService: DecsService,
    private alertService: AlertService
  ) {}

  submitDecsRequest(
    cmd: string,
    isRefresh: boolean
  ): Observable<RequestState<SabreText>> {
    return this.decsService.submitDecsRequest({ cmd }, isRefresh).pipe(
      map((requestState) => {
        return this.mapResponse(requestState);
      })
    );
  }

  mapResponse(
    requestState: RequestState<DecsResponse>
  ): RequestState<SabreText> {
    if (requestState.hasError) {
      this.showErrorAlert();
    }

    if (!requestState.response) {
      return requestState.into<SabreText>();
    }

    const sabreText = new SabreText(
      requestState.response?.result || '',
      requestState.response.timestamp
    );

    return requestState.into<SabreText>(sabreText);
  }

  private showErrorAlert(): void {
    this.alertService.setAlert({
      type: 'error',
      message: 'Sabre request failed.',
    });
  }
}
